'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_Account(id_$_lo, id_$_hi, name, calendarId, shoppingListId, accountPreferences, deleted) {
  this.nT = 0;
  this.nU = 0;
  this.wy = null;
  this.pZ = null;
  this.wz = null;
  this.ii = null;
  this.wx = false;
  this.nT = id_$_lo;
  this.nU = id_$_hi;
  this.wy = name;
  this.pZ = calendarId;
  this.wz = shoppingListId;
  this.ii = accountPreferences;
  this.wx = deleted;
}
export { $c_Lmealorama_Account as $c_Lmealorama_Account };
$p = $c_Lmealorama_Account.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Account;
/** @constructor */
function $h_Lmealorama_Account() {
}
export { $h_Lmealorama_Account as $h_Lmealorama_Account };
$h_Lmealorama_Account.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 487334413);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.nT, this.nU)));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.wy));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.pZ));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.wz));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.ii));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.wx ? 1231 : 1237));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 6);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_Account)) {
    if ((this.wx === x$0.wx)) {
      var x_$_lo = this.nT;
      var x_$_hi = this.nU;
      var $x_4 = x$0;
      var x$1_$_lo = $x_4.nT;
      var x$1_$_hi = $x_4.nU;
      var $x_3 = (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      var $x_3 = false;
    }
    if (($x_3 && (this.wy === x$0.wy))) {
      var x$2 = this.pZ;
      var x$2$1 = x$0.pZ;
      var $x_2 = ((x$2 === null) ? (x$2$1 === null) : x$2.f(x$2$1));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.wz;
      var x$4 = x$0.wz;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.ii;
      var x$6 = x$0.ii;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 6;
});
$p.r = (function() {
  return "Account";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.nT, this.nU);
      break;
    }
    case 1: {
      return this.wy;
      break;
    }
    case 2: {
      return this.pZ;
      break;
    }
    case 3: {
      return this.wz;
      break;
    }
    case 4: {
      return this.ii;
      break;
    }
    case 5: {
      return this.wx;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_Account(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.je)));
}
export { $isArrayOf_Lmealorama_Account as $isArrayOf_Lmealorama_Account };
var $d_Lmealorama_Account = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Account, "mealorama.Account", ({
  je: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_Account as $d_Lmealorama_Account };
//# sourceMappingURL=mealorama.-Account.js.map
